import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

import {
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableFooter,
  Autocomplete
} from "@mui/material";

import EditIcon from "@mui/icons-material/EditSquare";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import Serverurl from "./Apiurl";

class Expenses extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
	  
	  exp_pj_id:"",
      exp_date:"",
      exp_categoryname:"",
	  
	  projectId: "",

      selectedProject: null,
      projectarrauto: [],

      categoryId: "",
      selectedCategory: null,
      expensearrauto: [],

      reportData: [],

      page: 0,
      rowsPerPage: 50,
      totalRecords: 0,
      totalAmount: 0,

      loading: false
    };
  }

  componentWillMount() {

    document.title = "VR Builders - Expenses";

    if (this.props.parentsCallback) {
      this.props.parentsCallback("Expenses");
    }

    this.loadExpenseDropdown();

    this.apicall(
      this.state.page,
      this.state.rowsPerPage
    );
	
		let strname="Expenses";   
			 this.props.parentsCallback(
           strname
        );
  }

  onloadProjectBind = (event) => {

    const projectName =
      event?.target?.value?.trim() || "";

    if (!projectName) {
      this.setState({
        projectarrauto: []
      });
      return;
    }

    axios
      .get(Serverurl + "ajaxprojects.php", {
        params: {
          action: "getallprojectautoextender",
          projectname: projectName
        }
      })
      .then((res) => {

        const data =
          Array.isArray(res.data)
            ? res.data
            : [];

        const list = data.map((r) => ({
          title: r.pj_projectname || "",
          pj_id: r.pj_id
        }));

        this.setState({
          projectarrauto: list
        });

      })
      .catch((error) => {

        console.error(
          "Error loading projects:",
          error
        );

        this.setState({
          projectarrauto: []
        });

      });
  };

  onProjectChange = (event, value) => {

    this.setState({
      selectedProject: value,
      projectId: value
        ? value.pj_id
        : ""
    });
  };


  loadExpenseDropdown = () => {

    axios
      .get(
        Serverurl +
        "ajaxserviceandexpenses.php",
        {
          params: {
            action: "getalldropdown"
          }
        }
      )
      .then((res) => {

        console.log(
          "Expense dropdown response:",
          res.data
        );

        const data =
          Array.isArray(res.data)
            ? res.data
            : [];

        const list = data.map((r) => ({
          exp_id: r.se_id,
          expence: r.expence,
          se_servicename:
            r.se_servicename,
          se_type: r.se_type
        }));

        this.setState({
          expensearrauto: list
        });

      })
      .catch((error) => {

        this.setState({
          expensearrauto: []
        });

      });
  };

  onExpenseChange = (event, value) => {

    this.setState({
      selectedCategory: value,
      categoryId: value
        ? value.exp_id
        : ""
    });
  };


  apicall = (page, rowsPerPage) => {

    this.setState({
      loading: true
    });

    const fromDate =
      this.state.fromDate? this.state.fromDate.format("YYYY-MM-DD"): "";

    const toDate =this.state.toDate ? this.state.toDate.format("YYYY-MM-DD"): "";

    axios
      .get(
        Serverurl + "ajaxexpenses.php",
        {
          params: {
            action: "getexpensesall",
        exp_id: 0,

        from_date: fromDate,
        to_date: toDate,

        exp_pj_id: this.state.projectId || 0,
        exp_categoryname: this.state.categoryId || 0,

        StartIndex: page,
        PageSize: rowsPerPage,

        sorting: "exp.exp_id DESC"
          }
        }
      )
      .then((res) => {

        console.log(res.data);

        const data =
          Array.isArray(res.data)? res.data: [];

        let totalAmount = 0;

        data.forEach((item) => {

          totalAmount += Number(
            item.Amount ||
            item.exp_amount ||
            0
          );

        });

        this.setState({
          reportData: data,

          totalRecords:
            data.length > 0
              ? parseInt(
                  data[0].count || 0,
                  10
                )
              : 0,

          totalAmount,

          loading: false
        });

      })
      .catch((error) => {

        console.error(
          "Error loading expenses:",
          error
        );

        this.setState({
          reportData: [],
          totalRecords: 0,
          totalAmount: 0,
          loading: false
        });

      });
  };


  handleSearch = (event) => {

    if (event) {
      event.preventDefault();
    }

    this.setState(
      {
        page: 0
      },
      () => {

        this.apicall(
          0,
          this.state.rowsPerPage
        );

      }
    );
  };



  handlePageChange = (
    event,
    newPage
  ) => {

    this.setState(
      {
        page: newPage
      },
      () => {

        this.apicall(
          newPage,
          this.state.rowsPerPage
        );

      }
    );
  };

  handleRowsChange = (event) => {

    const rows =
      parseInt(
        event.target.value,
        10
      );

    this.setState(
      {
        rowsPerPage: rows,
        page: 0
      },
      () => {

        this.apicall(
          0,
          rows
        );

      }
    );
  };
 Expensedelete(exid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('exp_id',exid)
	 	   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxexpenses.php", formData, {
        }).then(res => {
    
          
   
 
this.apicall(this.state.page,this.state.rowsPerPage); 
  
    
            });
 }
      }


  downloadFile = (file) => {

    if (!file) {
      return;
    }

    window.open(
      Serverurl +
      "uploads/" +
      file,
      "_blank"
    );
  };


  render() {

    return (
      <React.Fragment>


        <div className="searchmaster">

          <ul>

           <li>

              <p>From Date</p>

              <p>

                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >

                  <DatePicker
                    disableFuture
                    format="DD/MM/YYYY"
                    value={
                      this.state.fromDate
                    }
                    onChange={(value) =>
                      this.setState({
                        fromDate: value
                      })
                    }
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true
                      }
                    }}
                  />

                </LocalizationProvider>

              </p>

            </li>

            <li>

              <p>To Date</p>

              <p>

                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                >

                  <DatePicker
                    disableFuture
                    format="DD/MM/YYYY"
                    value={
                      this.state.toDate
                    }
                    onChange={(value) =>
                      this.setState({
                        toDate: value
                      })
                    }
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true
                      }
                    }}
                  />

                </LocalizationProvider>

              </p>

            </li>


            <li>

              <p>Project</p>

              <p>

                <Autocomplete
                  className="inputcntlparent"

                  options={
                    this.state.projectarrauto
                  }

                  value={
                    this.state.selectedProject
                  }

                  onChange={
                    this.onProjectChange
                  }

                  getOptionLabel={(option) =>
                    option?.title || ""
                  }

                  isOptionEqualToValue={(
                    option,
                    value
                  ) =>
                    option?.pj_id ===
                    value?.pj_id
                  }

                  renderInput={(params) => (

                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      placeholder="Select Project"
                      onChange={
                        this.onloadProjectBind
                      }
                    />

                  )}

                />

              </p>

            </li>


            <li>

              <p>Expense</p>

              <p>

                <Autocomplete
                  className="inputcntlparent"

                  options={
                    this.state.expensearrauto
                  }

                  value={
                    this.state.selectedCategory
                  }

                  onChange={
                    this.onExpenseChange
                  }

                  getOptionLabel={(option) =>
                    option?.se_servicename || ""
                  }

                  isOptionEqualToValue={(
                    option,
                    value
                  ) =>
                    option?.exp_id ===
                    value?.exp_id
                  }

                  renderInput={(params) => (

                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      placeholder="Select Expense"
                    />

                  )}

                />

              </p>

            </li>


            <li>

              <p>

                <Button
                  variant="contained"
                  className="exportbtn"
                  onClick={
                    this.handleSearch
                  }
                  endIcon={
                    <SearchIcon />
                  }
                >
                  Search
                </Button>

                <Link
                  to="/ExpenseForm"
                >

                  <Button
                    variant="contained"
                    sx={{
                      marginLeft: "10px"
                    }}
                    endIcon={
                      <AddIcon />
                    }
                  >
                    New
                  </Button>

                </Link>

              </p>

            </li>

          </ul>

        </div>


        <TableContainer
          sx={{
            mt: 3
          }}
        >

          <Table>

            <TableHead>

              <TableRow>

                <TableCell>
                  Project
                </TableCell>

                <TableCell>
                  Date
                </TableCell>

                <TableCell>
                  Expense
                </TableCell>

                <TableCell>
                  Amount
                </TableCell>

                <TableCell>
                  Remarks
                </TableCell>

                <TableCell>
                  Bill
                </TableCell>

                <TableCell>
                  Image
                </TableCell>

                <TableCell>
                </TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              {this.state.reportData.map(
                (r, index) => (

                  <TableRow
                    key={
                      r.exp_id || index
                    }
                  >

                    <TableCell>
                      {
                        r.ProjectName ||
                        r.pj_projectname ||
                        ""
                      }
                    </TableCell>

                    {/* DATE */}

                    <TableCell>

                      {
                        r.ExpenseDate
                          ? dayjs(
                              r.ExpenseDate
                            ).format(
                              "DD-MM-YYYY"
                            )
                          : ""
                      }

                    </TableCell>



                    <TableCell>

                      {
                        r.CategoryName ||
                        r.se_servicename ||
                        ""
                      }

                    </TableCell>

  

                    <TableCell>

                      Rs.{" "}

                      {Number(
                        r.Amount ||
                        r.exp_amount ||
                        0
                      ).toFixed(2)}

                    </TableCell>

                    {/* REMARKS */}

                    <TableCell>

                      {
                        r.Remarks ||
                        r.exp_remarks ||
                        ""
                      }

                    </TableCell>


                    <TableCell>

                      {r.bill ? (

                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            this.downloadFile(
                              r.bill
                            )
                          }
                        >

                          <FileDownloadIcon />

                        </Button>

                      ) : (

                        "No Bill"

                      )}

                    </TableCell>

                    <TableCell>

                      {r.Photo ? (

                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            this.downloadFile(
                              r.Photo
                            )
                          }
                        >

                          <FileDownloadIcon />

                        </Button>

                      ) : (

                        "No Image"

                      )}

                    </TableCell>

                    {/* EDIT */}

                    <TableCell>
					{r.pj_isactive==="0" && (
					<>
                      <Link
                        to={
                          "/ExpenseForm?exp_id=" +
                          r.exp_id
                        }
                      >

                        <Button
                          variant="contained"
                          className="editbtn"
                          endIcon={
                            <EditIcon />
                          }
                        /></Link>
						
<Button variant="contained" className="deletebtn" onClick={()=>{this.Expensedelete(r.exp_id)}} endIcon={<DeleteIcon />}>

</Button> 
</>
					)}
                    </TableCell>

                  </TableRow>

                )
              )}

              {this.state.reportData.length ===
                0 &&
                !this.state.loading && (

                  <TableRow>

                    <TableCell
                      colSpan={8}
                      align="center"
                    >
                      No Records
                    </TableCell>

                  </TableRow>

                )}

              {this.state.loading && (

                <TableRow>

                  <TableCell
                    colSpan={8}
                    align="center"
                  >
                    Loading...
                  </TableCell>

                </TableRow>

              )}


              <TableRow>

                <TableCell
                  colSpan={3}
                >

                  <b>
                    Total
                  </b>

                </TableCell>

                <TableCell>

                  <b>

                    Rs.{" "}

                    {this.state.totalAmount.toLocaleString(
                      "en-IN",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }
                    )}

                  </b>

                </TableCell>

                <TableCell
                  colSpan={4}
                />

              </TableRow>

            </TableBody>

            <TableFooter>

              <TableRow>

                <TableCell
                  colSpan={8}
                />

              </TableRow>

            </TableFooter>

          </Table>

          <TablePagination
            rowsPerPageOptions={[
              50,
              100,
              150,
              200,
              250
            ]}
            component="div"
            count={
              this.state.totalRecords
            }
            page={
              this.state.page
            }
            onPageChange={
              this.handlePageChange
            }
            rowsPerPage={
              this.state.rowsPerPage
            }
            onRowsPerPageChange={
              this.handleRowsChange
            }
          />

        </TableContainer>

      </React.Fragment>
    );
  }
}

export default Expenses;

